/* eslint-disable import/prefer-default-export,no-new,no-console */

import api from '../../util/api';

export default {
    authenticate (user) {
        return new Promise((resolve, reject) => {
            api.post('/auth/authenticate', user)
                .then((resp) => {
                    const token = resp.token;
                    resolve(token);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    requestNewToken () {
        return new Promise((resolve, reject) => {
            api.get('/auth/refresh')
                .then((resp) => {
                    const token = resp.token;
                    resolve(token);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

    currentUser () {
        return new Promise((resolve, reject) => {
            api.get('/auth/current')
                .then(resp => resolve(resp))
                .catch(err => reject(err));
        });
    },

    logout () {
        return new Promise((resolve, reject) => {
            api.post('/auth/invalidate')
                .then(resp => resolve(resp))
                .catch(err => reject(err));
        });
    },
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth.js